module.exports = __webpack_public_path__ + "static/media/insta.53f59a92.svg";